import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetUserInfoAction } from '../../../../store/sso/sso.actions';
import { SsoValidateTokenService } from '../../../../core/services/sso-validate-token/sso-validate-token.service';

@Component({
  selector: 'app-sso-callback',
  template:
    '<div class="flex items-center justify-center h-screen">Validando acceso...</div>',
})
export class SsoCallbackComponent implements OnInit {
  private processed = false;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private ssoService: SsoValidateTokenService
  ) {}

  ngOnInit() {
    if (this.processed) {
      return;
    }

    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const refreshToken = params['refreshToken'];
      if (token && !this.processed) {
        this.processed = true;
        this.store.dispatch(
          new SetUserInfoAction({
            accessToken: token,
            refreshToken: refreshToken,
          })
        );
      } else if (!token && !this.processed) {
        this.processed = true;
        this.ssoService.redirectToSso();
      }
    });
  }
}
